import DashboardLayout from "../layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "../pages/NotFoundPage.vue";

// Admin pages
const Home = () => import('src/pages/Home/Home.vue');
const Lottery = () => import('src/pages/Lottery.vue');
const WheelPlay = () => import('src/pages/WheelPlay.vue');
const NeverHave = () => import('src/pages/NeverHave/NeverHave.vue');
const FingerSelector = () => import('src/pages/FingerSelector/FingerSelector.vue');
const WhereIsIt = () => import('src/pages/WhereIsIt/WhereIsIt.vue');
const Simon = () => import('src/pages/Simon/Simon.vue');
const TruthOrDrink = () => import('src/pages/TruthOrDrink/TruthOrDrink.vue');

var routes = [
  {
    path: "/",
    component: Home,
    redirect: "/home",
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/overview",
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
      },
      {
        path: "lottery",
        name: "Lottery",
        component: Lottery,
      },
      {
        path: "wheel-play",
        name: "WheelPlay",
        component: WheelPlay,
      },
      {
        path: "finger-selector",
        name: "FingerSelector",
        component: FingerSelector,
      },
      {
        path: "where-is-it",
        name: "WhereIsIt",
        component: WhereIsIt,
      },
      {
        path: "simon",
        name: "Simon",
        component: Simon,
      },
    ],
  },
  { path: "*", component: NotFound },
];
const linguaPortuguesa =
  navigator.language === "pt" ||
  navigator.language === "pt-BR" ||
  navigator.language === "pt-PT";
if (linguaPortuguesa) {
  routes[1].children.push({
    path: "never-have",
    name: "NeverHave",
    component: NeverHave,
  });
} else {
  routes[1].children.push({
    path: "truth-or-drink",
    name: "TruthOrDrink",
    component: TruthOrDrink,
  });
}

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
